import BannerFormPage from "./BannerFormPage";

export default function BannerEdit() {
  return (
    <BannerFormPage
      mode="edit"
      bannerType="main"
      pageTitle="Edit Banner"
      breadcrumbTitle="Edit Banner"
      backPath="/banner"
      successMessage="Banner updated successfully"
    />
  );
}
